//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { MessageBox } from 'element-ui'
export default {
    props:{
        pageConfig:Object,
        list:Array,
        total:Number
    },
    data(){
        return{
            currentPage:1,
        }
    },
    methods:{
        formatState(state){
            let str='';
            switch (state){
                case -1:
                    str='已作废';
                    break;
                case 1:
                    str='未使用';
                    break;
                case 2:
                    str='已使用';
                    break;
                case 3:
                    str='已过期';
                    break;
                case 4:
                    str='已退回';
                    break;
            }
            return str
        },
        update(id){
            this.$emit('update',id)
        },
        canel(id){
            MessageBox.confirm('你确定要作废这条停车券吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                customClass: this.$isMobile?'el-message-box-style':'',
                type: 'warning'
            }).then(() => {
                this.$emit('canel',{discountId:id})
            }).catch(()=>{});
        },
        pageChange(value) {
            this.$parent.pageConfig.current = value
            this.$emit('pageChange')
        },
        sizeChange(value) {
            this.$parent.pageConfig.pageSize = value
            this.$emit('pageChange')
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/create/Table.vue